export default {
  spendField: 'spend_ltd',
  interpolateMonths: true,
  trendMetrics: []
};



// WEBPACK FOOTER //
// ./src/app/configuration/FinancialServicesBanking/config/components/scorecard/Trendchart/index.js